import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { gql, useQuery } from "@apollo/client"
import DataTable from "react-data-table-component"
import PPLoadingIndicator from "./layout/PPLoadingIndicator"

const SUBSCRIPTION_CUSTOMERS_QUERY = gql`
    query getSubscriptionCustomers {
        subscriptionCustomers {
            customerId
            name
            email
            subscriptionTypeName
            subscriptionExpiration
            active
            productCount
            tokens
            tokensPerDay
        }
    }
`

export function PPSubscriptionCustomers() {
    const [t, i18n] = useTranslation()

    const { loading, data } = useQuery(SUBSCRIPTION_CUSTOMERS_QUERY, {
        fetchPolicy: "no-cache"
    })

    const columns = useMemo(
        () => [
            {
                name: t("admin.subscription_customers.id"),
                selector: (row) => row.customerId,
                width: "70px",
                sortable: true
            },
            {
                name: t("admin.subscription_customers.name"),
                selector: (row) => row.name,
                sortable: true,
                wrap: true
            },
            {
                name: "E-Mail",
                selector: (row) => row.email,
                sortable: true,
                wrap: true
            },
            {
                name: t("admin.subscription_customers.subscription_type"),
                selector: (row) => row.subscriptionTypeName,
                sortable: true
            },
            {
                name: t("admin.subscription_customers.product_count"),
                selector: (row) => row.productCount,
                sortable: true,
                right: true
            },
            {
                name: t("admin.subscription_customers.tokens"),
                selector: (row) => row.tokens,
                sortable: true,
                right: true
            },
            {
                name: t("admin.subscription_customers.tokens_per_day"),
                selector: (row) => row.tokensPerDay,
                cell: (row) => Number(row.tokensPerDay ?? 0).toFixed(2),
                sortable: true,
                right: true
            },
            {
                name: t("admin.subscription_customers.expiration"),
                selector: (row) => row.subscriptionExpiration,
                cell: (row) =>
                    row.subscriptionExpiration
                        ? new Date(row.subscriptionExpiration).toLocaleDateString(i18n.language)
                        : "-",
                sortable: true
            },
            {
                name: t("admin.subscription_customers.active"),
                selector: (row) => row.active,
                cell: (row) => (row.active ? t("single.yes") : t("single.no"))
            }
        ],
        [t, i18n.language]
    )

    if (loading) return <PPLoadingIndicator />

    const customers = data?.subscriptionCustomers ?? []

    if (customers.length === 0) {
        return <div className="mt-3 alert alert-info">{t("admin.subscription_customers.empty")}</div>
    }

    return (
        <div className="mt-3 datatable_headerbold datatable_specialpadding">
            <DataTable
                noHeader
                columns={columns}
                data={customers}
                defaultSortFieldId={1}
                defaultSortAsc={false}
                pagination
            />
        </div>
    )
}
